<app-loading-spinner *ngIf="appService.isLoading"></app-loading-spinner>
<div class="contact-container body-content-area">
    <div class="action-area">
        <div class="breadcrumb-area left-align">
            <p><a routerLink="/home"><u>Home</u> </a><span> > </span>
                <a routerLink="/home/bidpack"><u>Bid Pack</u> </a><span> > </span>
                <span class="heading"> {{operation}} Bid Pack</span> 
                @if (operation!=='add') {
                    <span class="heading">({{BidpackDataSource.BidPackReference}})</span>
                }
            </p>
        </div>
        <div class="header-area left-align btn-container">
            @if (operation!=='add') {
                <span class="sub-title">({{BidpackDataSource.BidPackReference}})</span>
            }
            @else {
                <span class="sub-title">New Bid Pack</span>
            }
            <div class="action-bts">
                <button mat-button-primary class="btn white-red-btn" (click)="onbackCall()">Back</button>
                @if (operation!=='view') {
                    @if(operation !="add"){
                        @if(BidpackDataSource.BidPackStatus!== 'Terminated'){
                        <button mat-button-primary *ngIf="BidpackDataSource.BidPackStatus !== 'Active'" class="btn white-red-btn" (click)="onDelete()">Delete</button>
                        <button mat-button-primary class="btn white-red-btn" (click)="onCopy()">Copy</button>
                        }
                        <button mat-button-primary class="btn red-white-btn" (click)="onSave()">Save</button>
                    }
                    @else{
                        <button mat-button-primary  [ngClass]="bidpackForm.valid && this.dataSource.data.length >0?'enable-btn':'disable-btn'" class="btn red-white-btn" (click)="onSave()">Save</button>
                    }
                }
            </div>
        </div>
    </div>

    <div class="agreement-form-area body-data">
        <div class="agreement-area">
            <form class="form" [formGroup]="bidpackForm">
                <table class="form-container" cellspacing="0">
                    <tr>
                        <div class="title" style="display: flex;width: fit-content;">Bid Pack Details
                            <button *ngIf="operation !== 'add'" class="btn" [ngClass]="BidpackDataSource.BidPackStatus === 'Active'?'green-white-btn':(BidpackDataSource.BidPackStatus === 'Not Active'?'amber-white-btn':'grey-white-btn')">{{BidpackDataSource.BidPackStatus ? BidpackDataSource.BidPackStatus:'Not Active'}}</button>
                        </div>
                    </tr>
                    <tr class="accord-area">
                        <div class="input-item" [ngClass]="this.operation === 'add'?'enable-field':'disable-field'" (keydown)="onKeyDown($event, this.operation === 'add')">
                            <label for='reference' class='required-icon innerLabel'>Bid Pack Reference</label>
                            <input type='text' name="reference" formControlName="reference" size='50'
                                placeholder="Enter Bid Pack Reference" [tabindex]="operation === 'add' ? 1 : -1" />
                        </div>

                        <div class="input-item">
                            <label for='name' class='required-icon innerLabel'>Bid Pack Name</label>
                            <input type='text' name="name" formControlName="name" size='50'
                                placeholder="Enter Bid Pack Name"  tabindex="1"/>
                        </div>

                        <div class="input-item">
                            <mat-form-field appearance="outline">
                                <mat-label >Bid Pack Type <span class='required-icon innerLabel'></span></mat-label>
                                <mat-select [multiple]="true" formControlName="bidpackType"  tabindex="1">
                                    <!-- <mat-option disabled value="" [selected]="false">Select Bidpack Type</mat-option> -->
                                  <mat-option *ngFor="let option of bidpackTypeList" [value]="option.LookUpID">
                                    {{option.LookUpName}}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                        </div>

                        <div class="input-item">
                            <label for='destination' class='required-icon innerLabel'>Destination Name</label>
                            <input type='text' name="destination" formControlName="destination" size='50'
                                placeholder="Enter Destination Name"  tabindex="1"/>
                        </div>

                        <div class="disable-field input-item" (keydown)="onKeyDown($event)">
                            <label for='createdAt' class='innerLabel'>Created (Date/Time)</label>
                            <input type="text" name="createdAt" formControlName="createdAt" size='50'
                                placeholder="Enter Created (Date/Time)"  tabindex="-1"/>
                        </div>

                        <div class="input-item disable-field" (keydown)="onKeyDown($event)">
                            <label for='createdBy' class='innerLabel'>Created By</label>
                            <input type='text' name="createdBy" formControlName="createdBy" size='50'
                                placeholder="Enter Created By"  tabindex="-1"/>
                        </div>

                        <div class="disable-field input-item" (keydown)="onKeyDown($event)">
                            <label for='modifiedAt' class='innerLabel'>Modified (Date/Time)</label>
                            <input type="text" name="modifiedAt" formControlName="modifiedAt" size='50'
                                placeholder="Enter Modified (Date/Time)"  tabindex="-1"/>
                        </div>

                        <div class="input-item disable-field" (keydown)="onKeyDown($event)">
                            <label for='modifiedBy' class='innerLabel'>Modified By</label>
                            <input type='text' name="modifiedBy" formControlName="modifiedBy" size='50'
                                placeholder="Enter Modified By"  tabindex="-1"/>
                        </div>
                    </tr>
                </table>
            </form>

            <div class="form-container" cellspacing="0">
                <div style="display: flex;justify-content: space-between;">
                    <div class="title" style="display: flex;width: fit-content;">Origin Region</div>
                    <div class="btn-right-area" style="display: inline-flex;align-items: center;">
                        @if(operation !== 'view')
                        {
                        <!-- @if(!(operation === 'edit' && BidpackDataSource.BidPackStatus === 'Active')){ -->
                        <button mat-button-primary class="btn white-red-btn" style="padding: 0px 5px" [ngClass]="{'clickable': tableService.disablingDownload(this), 'non-clickable': !tableService.disablingDownload(this)}"
                            (click)="onDeleteRow()"><mat-icon>delete</mat-icon><span>Delete Row</span> </button>
                        <button mat-button-primary class="btn white-red-btn" style="padding: 0px 5px"
                            (click)="onAddNewRow()"><mat-icon>add</mat-icon><span>Add New Row</span></button>
                        <img (click)="onImportData()" class="download-icon icons" style="transform: rotate(180deg);"
                            src="../../../../assets/images/download-icon.png" alt="Profile Picture">
                        <!-- } -->
                    }
                        <img (click)="onExportdata()" *ngIf="operation !='add'" class="download-icon icons" [ngClass]="{'clickable': tableService.disablingDownload(this), 'non-clickable': !tableService.disablingDownload(this)}"
                        src="../../../../assets/images/download-icon.png" alt="Profile Picture">
                        
                    </div>

                </div>

                <div class="mat-table-area">
                    <hr style="width: 100%;">
                    <table mat-table [dataSource]="dataSource" [formGroup]="contactTableForm" matSort [ngStyle]="(operation === 'view') ? { 'pointer-events': 'none', 'opacity':0.7 }:{'pointer-events': 'auto','opacity':1}"
                        (matSortChange)="tableService.announceSortChange(this,$event,'')" class="mat-elevation-z8">

                        @for (i of displayedColumns; track i; let ind=$index) {
                            @if (i.name === 'Selected') {
                            <ng-container matColumnDef={{i.name}}>
                                <th mat-header-cell *matHeaderCellDef style="width: 3%;pointer-events: all;" (keydown)="onKeyDownOnTable($event)">
                                    <div style="display: inline-flex;">
                                        <input type="checkbox" id="all" name="all" [checked]="allSelected" style="left: 0px;top:10px;position: relative;"
                                            (change)="tableService.selectAllItem(this)">
                                      </div>

                                </th>
                                <td mat-cell *matCellDef="let element; let ind=index" (keydown)="onKeyDownOnTable($event)">
                                    <div style="display: inline-flex;box-sizing: content-box;pointer-events: all;">
                                        <input type="checkbox" id={{element.CountryID}} name={{element.CountryID}} [checked]="element.Selected"
                                            (change)="tableService.selectItem(ind,this,'bidpack-origin')">
                                    </div>
                                </td>
                            </ng-container>
                            }
                            @else if(i.name === 'OriginCountry'){
                                <ng-container matColumnDef={{i.name}}>
                                    <th mat-header-cell class="scrollable" *matHeaderCellDef (keydown)="onKeyDownOnTable($event)">
                                        <div mat-sort-header class="country-header">{{i.label}} <span class="required-icon"></span></div>
                                        <div class="origin">
                                            <input matInput class="form-field" [formControlName]="i.name+'Filter'"
                                                placeholder="Filter">

                                        </div>
                                    </th>
                                    <td class="scrollable country-item" mat-cell *matCellDef="let element;let ind=index" (keydown)="onKeyDownOnTable($event)"> 
                                        <select required (change)="onCheckValue($event.target,i.name, ind)" >
                                            <option *ngIf="element['CountryID']===0">Choose</option>
                                            <option *ngFor="let option of countryListArr" [value]="option.CountryID" [selected]="(element['CountryID'] === option.CountryID)">
                                                {{ option.CountryName }}
                                            </option>                                            
                                        </select>
                                    </td>
                                </ng-container>
                                }
                            @else{
                            <ng-container matColumnDef={{i.name}}>
                                <th mat-header-cell class="scrollable" *matHeaderCellDef (keydown)="onKeyDownOnTable($event)">
                                    <div mat-sort-header>{{i.label}}</div>
                                    <div class="origin">
                                        <input matInput class="form-field" [formControlName]="i.name+'Filter'"
                                            placeholder="Filter">
                                    </div>
                                </th>
                                <td class="scrollable" mat-cell *matCellDef="let element;let ind=index" (keydown)="onKeyDownOnTable($event)">
                                     <div>
                                        <input matInput class="form-field" (change)="onCheckValue($event.target,i.name, ind)" value="{{element[i.name]}}"
                                            placeholder="">
                                            
                                    </div>
                                </td>
                            </ng-container>
                            }
                        }
                        <tr mat-header-row *matHeaderRowDef="dataColList"></tr>
                        <tr mat-row *matRowDef="let row; columns: dataColList;"></tr>
                    </table>
                    <hr style="width: 100%;">
                </div>

            </div>
        </div>
    </div>

    
</div>